import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const BackupRestoreModal = ({ show, handleClose, exportData, importData }) => {
  const [importFile, setImportFile] = useState(null);

  const handleFileChange = (e) => {
    setImportFile(e.target.files[0]);
  };

  const handleImport = (e) => {
    e.preventDefault();
    if (!importFile) {
      alert("ファイルを選択してください。");
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const importedData = JSON.parse(event.target.result);
        if (
          window.confirm(
            "既存のデータを上書きしますか？ 上書きすると現在のデータは失われます。"
          )
        ) {
          importData(importedData, true); // 上書きフラグを追加
        } else {
          importData(importedData, false); // 追加のみ
        }
        handleClose();
      } catch (error) {
        alert(
          "データの復元に失敗しました。正しいバックアップファイルを使用してください。"
        );
      }
    };
    reader.readAsText(importFile);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>バックアップ / 復元</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between mb-3">
          <Form onSubmit={handleImport}>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>バックアップファイルを選択</Form.Label>
              <Form.Control
                type="file"
                accept=".json"
                onChange={handleFileChange}
                required
              />
            </Form.Group>
            <Button variant="outline-secondary" onClick={exportData}>
              <i className="bi bi-download"></i> バックアップ
            </Button>
            <Button variant="outline-secondary" type="submit">
              <i className="bi bi-upload"></i> 復元
            </Button>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          閉じる
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BackupRestoreModal;
